import '/components/reviews/reviews-carousel';
import '/components/reviews/reviews.scss';
import '/components/reviews/reviews-block.scss';
